// FinTrack — Excel/CSV/PDF export za nedeljni izvestaj

import { state } from './state.js';
import { sb } from './supabase.js';
import { toast } from './ui.js';
import { fNum, csvQ } from './utils.js';
import XLSX from 'xlsx-js-style';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

export function expXlsx(){if(!state.lastReport)return;const{groups,kurs,from,to,totalRsd,totalUsd}=state.lastReport;const wb=XLSX.utils.book_new();
  function borderAll(c){const b={style:'thin',color:{rgb:c}};return{top:b,bottom:b,left:b,right:b}}
  const stH={font:{bold:true,color:{rgb:'FFFFFF'},sz:11},fill:{fgColor:{rgb:'0F1923'}},alignment:{horizontal:'center'},border:borderAll('CCCCCC')};
  const stN={font:{sz:10},border:borderAll('E2E8F0')};
  const stU={font:{bold:true,sz:11,color:{rgb:'1A2738'}},fill:{fgColor:{rgb:'FEF08A'}},border:borderAll('D97706')};
  const stT={font:{bold:true,sz:13,color:{rgb:'FFFFFF'}},fill:{fgColor:{rgb:'0F1923'}},border:borderAll('1D4ED8')};
  const stNm={...stN,alignment:{horizontal:'right'},numFmt:'#,##0.000'};
  const stUm={...stU,alignment:{horizontal:'right'},numFmt:'#,##0.000'};
  const stTm={...stT,alignment:{horizontal:'right'},numFmt:'#,##0.000'};
  function cs(v,s){return{v,s,t:typeof v==='number'?'n':'s'}}
  const det=[];
  const curLabel='USD';
  det.push(['Vrsta troška','Vrsta (SR)','Komitent','Rok plaćanja','Dospelo RSD','Dospelo '+curLabel,'Dani kašnjenja'].map(h=>cs(h,stH)));
  for(const[k,g] of Object.entries(groups)){
    for(const it of g.items){const mx=it.details.length?Math.max(...it.details.map(d=>d.dk)):0;
      det.push([cs(k==='_unk'?'Nepoznato':g.meta.name_en,stN),cs(k==='_unk'?'':g.meta.name_sr||'',stN),cs(it.komitent,stN),cs(it.details.map(d=>d.rok).join(', '),stN),cs(it.dospelo,stNm),cs(+(it.dospelo/kurs).toFixed(3),stNm),cs(mx,{...stN,alignment:{horizontal:'center'}})])}
    if(g.items.length){det.push([cs('UKUPNO '+(k==='_unk'?'Nepoznato':g.meta.name_en),stU),cs('',stU),cs('',stU),cs('',stU),cs(g.total,stUm),cs(+(g.total/kurs).toFixed(3),stUm),cs('',stU)]);
    det.push([cs('',{}),cs('',{}),cs('',{}),cs('',{}),cs('',{}),cs('',{}),cs('',{})])}}
  det.push([cs('',{}),cs('',{}),cs('',{}),cs('',{}),cs('',{}),cs('',{}),cs('',{})]);
  det.push([cs('TOTAL OPEX',stT),cs('',stT),cs('',stT),cs('',stT),cs(totalRsd,stTm),cs(+(totalUsd).toFixed(3),stTm),cs('',stT)]);
  const ws=XLSX.utils.aoa_to_sheet(det.map(r=>r.map(c=>c.v)));
  ws['!cols']=[{wch:26},{wch:22},{wch:36},{wch:28},{wch:16},{wch:14},{wch:12}];
  det.forEach((row,ri)=>{row.forEach((cell,ci)=>{const addr=XLSX.utils.encode_cell({r:ri,c:ci});if(!ws[addr])ws[addr]={v:cell.v,t:cell.t||'s'};ws[addr].s=cell.s})});
  XLSX.utils.book_append_sheet(wb,ws,'Detaljan izveštaj');
  const sum=[];sum.push(['Vrsta troška','Vrsta (SR)','Br. komitenata','Ukupno RSD','Ukupno '+curLabel].map(h=>cs(h,stH)));
  for(const[k,g] of Object.entries(groups)){if(!g.items.length)continue;sum.push([cs(k==='_unk'?'Nepoznato':g.meta.name_en,stN),cs(k==='_unk'?'':g.meta.name_sr||'',stN),cs(g.items.length,{...stN,alignment:{horizontal:'center'}}),cs(g.total,stNm),cs(+(g.total/kurs).toFixed(3),stNm)])}
  sum.push([cs('',{}),cs('',{}),cs('',{}),cs('',{}),cs('',{})]);
  sum.push([cs('TOTAL OPEX',stT),cs('',stT),cs('',stT),cs(totalRsd,stTm),cs(+(totalUsd).toFixed(3),stTm)]);
  sum.push([cs('',{}),cs('',{}),cs('',{}),cs('',{}),cs('',{})]);
  const fmt2=d=>d.toLocaleDateString('sr-RS');
  sum.push([cs('Kurs',stN),cs('1 '+curLabel+' = '+kurs+' RSD',stN),cs('',{}),cs('',{}),cs('',{})]);
  sum.push([cs('Rok: '+fmt2(from)+' \u2013 '+fmt2(to),stN),cs('',{}),cs('',{}),cs('',{}),cs('',{})]);
  const ws2=XLSX.utils.aoa_to_sheet(sum.map(r=>r.map(c=>c.v)));
  ws2['!cols']=[{wch:26},{wch:22},{wch:14},{wch:16},{wch:14}];
  sum.forEach((row,ri)=>{row.forEach((cell,ci)=>{const addr=XLSX.utils.encode_cell({r:ri,c:ci});if(!ws2[addr])ws2[addr]={v:cell.v,t:cell.t||'s'};ws2[addr].s=cell.s})});
  XLSX.utils.book_append_sheet(wb,ws2,'Sumarno');
  const d1=from.toISOString().slice(0,10),d2=to.toISOString().slice(0,10);
  XLSX.writeFile(wb,'izvestaj_'+d1+'_'+d2+'.xlsx',{bookSST:false,cellStyles:true});sb.rpc('log_audit',{p_user_id:state.CU.id,p_action:'export_excel',p_entity_type:'nedeljni',p_entity_name:'izvestaj_'+d1+'_'+d2+'.xlsx'}).then(null, e => console.error('SBIS:', e));toast('Excel eksportovan')}

export function expPdf(){
  if(!state.lastReport)return;
  const{groups,kurs,from,to,totalRsd,totalUsd}=state.lastReport;
  const pdfCurLabel='USD';
  const doc=new jsPDF('l','mm','a4');
  const fmt=d=>d.toLocaleDateString('sr-RS');

  // Title
  doc.setFontSize(18);doc.setTextColor(15,25,35);
  doc.text('SBIS Consulting - Nedeljni izvestaj',14,20);
  doc.setFontSize(11);doc.setTextColor(100);
  doc.text('Period: '+fmt(from)+' - '+fmt(to)+'  |  Kurs: 1 '+pdfCurLabel+' = '+fNum(kurs)+' RSD',14,28);

  // Summary table
  const sumRows=[];
  for(const[k,g] of Object.entries(groups)){
    if(!g.items.length)continue;
    sumRows.push([
      k==='_unk'?'Nepoznato':g.meta.name_en,
      k==='_unk'?'':g.meta.name_sr||'',
      g.items.length,
      fNum(g.total),
      fNum(g.total/kurs)
    ]);
  }
  sumRows.push(['TOTAL OPEX','',sumRows.reduce((s,r)=>s+r[2],0),fNum(totalRsd),fNum(totalUsd)]);

  doc.autoTable({
    startY:34,
    head:[['Vrsta troska','Vrsta (SR)','Kom.','Dospelo RSD','Dospelo '+pdfCurLabel]],
    body:sumRows,
    theme:'grid',
    headStyles:{fillColor:[15,25,35],textColor:255,fontSize:9},
    bodyStyles:{fontSize:8},
    footStyles:{fillColor:[15,25,35],textColor:255},
    columnStyles:{2:{halign:'center'},3:{halign:'right'},4:{halign:'right'}},
    didParseCell:function(data){
      if(data.row.index===sumRows.length-1){data.cell.styles.fillColor=[15,25,35];data.cell.styles.textColor=255;data.cell.styles.fontStyle='bold';}
    }
  });

  // Detail table
  const detRows=[];
  for(const[k,g] of Object.entries(groups)){
    for(const it of g.items){
      const mx=it.details.length?Math.max(...it.details.map(d=>d.dk)):0;
      detRows.push([
        k==='_unk'?'?':g.meta.name_en,
        it.komitent,
        it.details.map(d=>d.rok).join(', '),
        fNum(it.dospelo),
        fNum(it.dospelo/kurs),
        mx
      ]);
    }
  }

  doc.autoTable({
    startY:doc.lastAutoTable.finalY+10,
    head:[['Kategorija','Komitent','Rok placanja','Dospelo RSD','Dospelo '+pdfCurLabel,'Kasnjenje']],
    body:detRows,
    theme:'grid',
    headStyles:{fillColor:[15,25,35],textColor:255,fontSize:8},
    bodyStyles:{fontSize:7},
    columnStyles:{3:{halign:'right'},4:{halign:'right'},5:{halign:'center'}}
  });

  // Footer
  const pageCount=doc.internal.getNumberOfPages();
  for(let i=1;i<=pageCount;i++){
    doc.setPage(i);doc.setFontSize(8);doc.setTextColor(150);
    doc.text('SBIS Consulting | Generisano: '+new Date().toLocaleString('sr-RS'),14,doc.internal.pageSize.height-8);
    doc.text('Strana '+i+'/'+pageCount,doc.internal.pageSize.width-30,doc.internal.pageSize.height-8);
  }

  const d1=from.toISOString().slice(0,10),d2=to.toISOString().slice(0,10);
  doc.save('izvestaj_'+d1+'_'+d2+'.pdf');
  sb.rpc('log_audit',{p_user_id:state.CU.id,p_action:'export_pdf',p_entity_type:'nedeljni',p_entity_name:'izvestaj_'+d1+'_'+d2+'.pdf'}).then(null, e => console.error('SBIS:', e));
  toast('PDF eksportovan');
}

export function expCsv(){if(!state.lastReport)return;const{groups,kurs,from,to}=state.lastReport;let c='\uFEFFVrsta troška;Vrsta SR;Komitent;Rok plaćanja;Dospelo RSD;Dospelo USD;Dani kašnjenja\n';for(const[k,g] of Object.entries(groups))for(const it of g.items){const mx=it.details.length?Math.max(...it.details.map(d=>d.dk)):0;c+=csvQ(k==='_unk'?'?':g.meta.name_en)+';'+csvQ(g.meta.name_sr||'')+';'+csvQ(it.komitent)+';'+csvQ(it.details.map(d=>d.rok).join(', '))+';'+csvQ(fNum(it.dospelo))+';'+csvQ(fNum(it.dospelo/kurs))+';'+csvQ(mx)+'\n'}const b=new Blob([c],{type:'text/csv'});const u=URL.createObjectURL(b);const a=document.createElement('a');a.href=u;a.download='fintrack.csv';a.click();URL.revokeObjectURL(u);sb.rpc('log_audit',{p_user_id:state.CU.id,p_action:'export_csv',p_entity_type:'nedeljni',p_entity_name:'fintrack.csv'}).then(null, e => console.error('SBIS:', e));toast('CSV eksportovan')}
